import { Component, OnInit } from '@angular/core';
import { HttpService, LocalStorageService, MenuBreadCrumb, SessionService } from 'brainloper-ui';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { ModalProfileComponent } from './modal-profile/modal-profile.component';
import { User } from 'app/models2/administration/user';
import { SizePicture } from 'app/models2/commos/size-pircture';


declare var require: any
const jsreport = require('jsreport-browser-client-dist');


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Perfil",
    current:true
  }]
  public dataProfile: Array<User>
  public userId: number = this.storage.get<number>('userId')
  public companyId = this.storage.get<number>('companyId')
  public userPicture: string
  private size: number
  public sizePicture: SizePicture
  public fechaIngreso: string
  public antiguedad:string
  private formProfile: UntypedFormGroup
  private curriculumVitae: string




  constructor(
    private http: HttpService,
    private session: SessionService,
    public dialog: MatDialog,
    private storage : LocalStorageService


  ) { }

  ngOnInit(): void {

    this.userId = this.storage.get<number>('userId')
    this.initValues()
  }

  async initValues(){
    let res:Array<User> = await this.http.getDataBody(`${EndpointDictionary.User.CRUD_USER_DATA}/${this.userId}`)

    if(res && res.length > 0){
      this.dataProfile = res
      this.tiempoServicio(this.dataProfile[0].dateJoining);
      this.curriculumVitae = `${EndpointDictionary.Base._BASE_URL_V2}${this.dataProfile[0].cv}/${this.companyId}`
      this.userPicture = `${EndpointDictionary.Base._BASE_URL_V2}${this.dataProfile[0].photo}/${this.companyId}`
    }
    this.picture()
  }

  picture() {

    this.size = ((screen.height + screen.width) / 2) * 0.22
    this.sizePicture = {
      'width': `${this.size}px`,
      'border-radius': '50%',
      'height': `${this.size}px`,
      'margin': '3px',
      'border': '1px solid black'
    }

  }


  tiempoServicio(date) {

    let today: Date = new Date()
    let fechaIngreso: Date = new Date(date)
    this.fechaIngreso = `${fechaIngreso.getFullYear()}/${fechaIngreso.getMonth() + 1}/${fechaIngreso.getDate()}`

    let dia: number = today.getDate() - fechaIngreso.getDate()
    let mes: number = (today.getMonth() + 1) - (fechaIngreso.getMonth() + 1)
    let año: number = today.getFullYear() - fechaIngreso.getFullYear()

    if (mes <= 0) {
      año = año - 1
      mes = mes + 12
    }
    if ( mes == 12 && año<0){
      mes = 0
      año = 0
    }


    if(mes>0 && dia<0){
      let d = new Date(); d.setFullYear(today.getFullYear(), today.getMonth(), 0);
      let u =d.getDate()
      dia = dia+u
      mes = mes - 1
    }

    if(dia>=0 && mes>0 && año>0){
      this.antiguedad = (`${Math.abs(año)} años , ${Math.abs(mes)} meses, ${Math.abs(dia)} dias`)
    }

    if(dia>0 && mes == 0 && año>0){
      this.antiguedad = (`${Math.abs(año)} años, ${Math.abs(dia)} dias`)

    }
    if(dia==0 && mes == 0 && año>0 ){
      this.antiguedad = (`${Math.abs(año)} años`)
    }

    if(dia>=0 && mes>0 && año==0){
      this.antiguedad = (`${Math.abs(mes)} meses, ${Math.abs(dia)} dias`)

    }

    if(dia>=0 && mes==0 && año==0){
      this.antiguedad = (`${Math.abs(dia)} dias`)
    }

    if(dia==0 && mes>0 && año==0){
      this.antiguedad = (`${Math.abs(mes)} meses`)

    }



  }


  modalEdit(type) {
    let sizeW:number = screen.width > 500 ? 80 : 50
    let sizeH:number = screen.height > 400 ? 80 : 120
    let size:number = (sizeW + sizeH) / 2

    this.dialog.open(ModalProfileComponent, {
      width: `${size}vh`,
      data: type

    }).afterClosed().subscribe(() => {
      this.initValues()
      // this.userId = this.storage.get<number>('userId')
      // this.http.getData(`${environment.endpoint}${EndpointDictionary.User.CRUD_USER_DATA}/${this.userId}/${this.companyId}`).subscribe(
      //   (res: BaseResponse<Array<User>>) => {
      //  //   console.log(res['body'])
      //     this.dataProfile = res['body']
      //     this.tiempoServicio(this.dataProfile[0].fecha_ingreso);
      //     this.curriculumVitae = `${environment.endpoint}/api/v1${this.dataProfile[0].cv}`
      //     this.userPicture = `${environment.endpoint}/api/v1${this.dataProfile[0].foto}`

      //   }
      // )


      }
      )
  }

  openCV() {

    event.preventDefault()

    let ancho:number = 800
    let alto:number = 700
    var x:number = (screen.width / 2) - (ancho / 2);
    var y:number = (screen.height / 2) - (alto / 2);
    window.open(this.curriculumVitae, 'popup', 'width=' + ancho + ', height=' + alto + ', left=' + x + ', top=' + y + '')

  }

  report() {

 jsreport.serverUrl = `http://165.227.92.103`


    let request = {
      "data": {
          "compania":{
              "name":"Cargando y Descargando",
              "nit":"102029495",
              "address":"km 1 via ubate - bogota",
              "telephone":"9983324",
              "mail":"c&d@hotmail.com",
              "image":"https://redempresarial.movilidadbogota.gov.co/sites/default/files/CargandoSA.png"
          },
          "OT":{
              "code":"KMC554",
              "date":"12-07-2020",
              "responsible":"Oskar Fernando Garzon",
              "third":"trienergy ",
              "odometer":"150000",
              "approved_by":"Edwar David Garzon Bello",
              "description":"Cambio de aceite de motor y engrace general, recursos: Filtros de aire 45222 y combustible 442, Cambio de aceite de motor y engrace general, recursos: Filtros de aire 45222 y combustible 442, Cambio de aceite de motor y engrace general",
              "consecutive":"345"
          },
          "tercero":{
              "name":"Surti Frenos",
              "address":"calle 13 # 23.45"
          }
      },
      "template": {
        "name": "OT_template"
      }
    }

    jsreport.render('_blank', request);

  }

}
